<section
    [id]="id()"
    class="relative w-full h-full"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [attr.data-uitype]="'graph-legend'"
        class="flex justify-end py-4 items-center pl-[80px] text-dat-grey-200"
    >
        <div class="flex items-center pr-[20px]">
            <span
                class="rounded-full h-2 w-2 bg-[#BA61EB] inline-block ml-4 mr-1"
            ></span>
            <label class="mr-4 font-caption-micro">Flatbed Spot</label>
            <span
                class="rounded-full h-2 w-2 ml-4 bg-[#6E0AD4] inline-block mr-1"
            ></span>
            <label class="font-caption-micro mr-1">Flatebd Contract</label>
        </div>
    </section>
    <section

        [attr.data-testid]="id() + '-graph'"
        [attr.data-styletarget]="id() + '-graph'"
        [attr.data-uitype]="'graph'"
        class="w-full h-full sm:!h-[300px]"
        #graph
    ></section>
</section>
<div [attr.data-json-info]="'rates-ntl-flatbed'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />
